/**
 * Langues prises en charge. `tts` : une voix existe ; `translate` : un modèle de traduction
 * est installé sur le service IA (directement ou en passant par l'anglais).
 * La transcription (Whisper) accepte toutes ces langues.
 */
export const LANGUAGES = [
  { code: 'en', label: 'Anglais', tts: true, translate: true },
  { code: 'fr', label: 'Français', tts: true, translate: true },
  { code: 'es', label: 'Espagnol', tts: true, translate: true },
  { code: 'it', label: 'Italien', tts: true, translate: true },
  { code: 'pt', label: 'Portugais', tts: true, translate: true },
  { code: 'de', label: 'Allemand', tts: false, translate: true },
  { code: 'hi', label: 'Hindi', tts: true, translate: false },
  { code: 'nl', label: 'Néerlandais', tts: false, translate: false },
  { code: 'pl', label: 'Polonais', tts: false, translate: false },
  { code: 'ru', label: 'Russe', tts: false, translate: false },
  { code: 'tr', label: 'Turc', tts: false, translate: false },
  { code: 'ar', label: 'Arabe', tts: false, translate: false },
  { code: 'ja', label: 'Japonais', tts: false, translate: false },
  { code: 'zh', label: 'Chinois', tts: false, translate: false },
  { code: 'ko', label: 'Coréen', tts: false, translate: false },
] as const;

export type LanguageCode = (typeof LANGUAGES)[number]['code'];

export const LANGUAGE_CODES = LANGUAGES.map((l) => l.code) as [LanguageCode, ...LanguageCode[]];

export const TRANSLATABLE_LANGUAGES = LANGUAGES.filter((l) => l.translate).map((l) => l.code);

/** Langues cibles possibles pour un doublage : il faut une traduction ET une voix. */
export const DUBBING_TARGETS = LANGUAGES.filter((l) => l.translate && l.tts).map((l) => l.code);

export function languageLabel(code: string): string {
  return LANGUAGES.find((l) => l.code === code)?.label ?? code.toUpperCase();
}
